import './style.css'

export default class PageHero {
    static selector = '.page-hero'

    constructor(block) {
        this.block = block;
        this.pageHeroImage = this.block.querySelector('.page-hero__loaded-image');

        this.checkIsImageLoaded();
    }

    checkIsImageLoaded() {
        if (!this.pageHeroImage) {
            return;
        }
        if (!this.pageHeroImage.complete) {
            setTimeout(() => {
                this.checkIsImageLoaded();
            }, 500);
        }
        if (this.pageHeroImage.complete) {
            this.pageHeroImage.classList.add('is-loaded');
            this.block.querySelector('.lazy').classList.add('is-hidden');
        }
    }
}
